import React, { FC, ReactElement } from 'react';

import { useTranslation } from 'react-i18next';
import { Controller, UseControllerReturn, UseFormReturn } from 'react-hook-form';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from '@mui/material';

import MqttConfig from './common/MqttConfiguration';
import BinaryDataConfig from './common/BinaryDataConfig';
import ConnectForm from '../../../../common/reactHookForm/ConnectForm';
import { stringOrNull } from '../../utils/SetValueAsUtil';
import {
  GPRSConfigModel,
  PreferredNetworkType,
  GprsRadioMode,
  TrashCollectionTruckConfigModel,
} from '@thingslog/repositories';

const TrashTructConfiguration: FC<TrashTruckConfigModelProps> = () => {
  const { t } = useTranslation();

  return (
    <ConnectForm<TrashCollectionTruckConfigModel>>
      {({ register, control }: UseFormReturn<TrashCollectionTruckConfigModel>): ReactElement => (
        <div className="grid grid-cols-4 max-xl:grid-cols-3 max-lg:grid-cols-2 gap-5">
          <TextField
            {...register('brand')}
            label={t('device_initial_config_trash_truck_brand')}
            size="small"
          />
          <TextField
            {...register('plateNumber')}
            label={t('device_initial_config_trash_truck_plate_number')}
            size="small"
          />
          <TextField
            {...register('model')}
            label={t('device_initial_config_trash_truck_model')}
            size="small"
          />
        </div>
      )}
    </ConnectForm>
  );
};

interface TrashTruckConfigModelProps {}

export default TrashTructConfiguration;
